import type { AccountStatus } from '../types';

export const STATUS_LABELS: Record<AccountStatus, string> = {
  test: 'Prueba',
  healthy: 'Activo',
  pre_banned: 'Pre-ban',
  redemption_test: 'Redención',
  banned: 'Baneado',
  failed: 'Fallido',
  deleted: 'Archivado',
};

export type StatusBadgeVariant = 'success' | 'error' | 'warning' | 'default';

export const STATUS_VARIANTS: Record<AccountStatus, StatusBadgeVariant> = {
  test: 'default',
  healthy: 'success',
  pre_banned: 'warning',
  redemption_test: 'warning',
  banned: 'error',
  failed: 'error',
  deleted: 'default',
};
